import api from './api';

const botService = {
  // Get bot connection status
  getBotStatus: async () => {
    const response = await api.get('/bot/status');
    return response.data;
  },

  // Get current bot configuration
  getBotConfig: async () => {
    const response = await api.get('/bot/config');
    return response.data;
  },

  // Update bot configuration
  updateBotConfig: async (config) => {
    const response = await api.put('/bot/config', config);
    return response.data;
  },

  // Reload bot configuration
  reloadBotConfig: async () => {
    const response = await api.post('/bot/reload');
    return response.data;
  }
};

export default botService;
